import { useSnapshot } from "valtio"
import { filtersState, loginStore } from "../state/CommonState"
import { rtpStore } from "../pricing/pricing-store"
import LCLPricingSchedule from "../pricing/lcl.schedule"
import AirPricingSchedule from "../pricing/air.schedule"
import { getTotalResultCount } from "../mui-components/QuickQuoteFilters"
import RoleUtils from "../util/RoleUtils"
import { PERMISSIONS_NEW } from "../util/constants"
import { useMobile } from "../hooks/usemobile"

const ChargeTable = (props) => {
    /*return <p>
        {JSON.stringify(props.charge)}
    </p>*/
    return <>
        {
            Object.keys(props.charge).map(e => <tr>
                <td></td>
                <td>{e}</td>
                <td>{props.charge[e].category}</td>
                <td colSpan='2'>
                    {
                        props.charge[e].comp ?
                            Object.entries(props.charge[e].comp).map(e1 => '' + e1 + ', ') :
                            'Comp undefined'
                    }
                </td>
                <td>
                {
                     ((e==="Pick-up Charges" && props.charge[e].total===0) || (e==="Delivery Charges" && props.charge[e].total===0)) ?
                     "Charges awaited"
                     : <>
                    Total = {props.charge[e].total} {
                        typeof props.charge[e].markup != 'undefined' && props.charge[e].markup != 0 ? '(' + props.charge[e].markup + ')' : ''
                    }
                    </>
                }
                </td>
            </tr>)
        }
    </>
}
export default function SpotAirDisplayv3(props) {
    useSnapshot(loginStore)
    useSnapshot(rtpStore)
    let routes = props.routes
    let cwfVisible = props.cwfVisible
    let setcwfVisible = props.setcwfVisible
    const isMobile = useMobile()

    return (
        <>
            <table className={isMobile ? "is-fullwidth" : "table is-bordered is-fullwidth is-narrow "} style={{ width: '100%', fontSize: '0.75rem', padding: '0px' }}>
                {
                    (!loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.RATE_SOURCES) && !isMobile) ?
                        <thead>
                            <tr>
                                <th colSpan={7}>Total Routes =  {routes.length}{props.filteredRoutes?.length ? " / " + getTotalResultCount(props.filteredRoutes) : ""}, Displaying max 100 routes</th>
                            </tr>
                            <tr>
                                <th>Set #</th>
                                <th>IATA</th>
                                <th>AOR</th>
                                <th>AOD</th>
                                
                                <th>AOA</th>
                                <th>FPOD</th>
                            </tr>
                        </thead>
                        : <></>
                }
                <tbody>
                    {
                        routes?.slice(0, 100).map((route, subscript) =>{
                             let e = filtersState.routes.find(({ uid }) => uid === route.refId);
                             subscript = filtersState.routes.findIndex(({ uid }) => uid === route.refId)
                            return  <>
                            {
                                (!loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.RATE_SOURCES) && !isMobile) ?
                                    <tr style={{ fontWeight: 'bold' }}>
                                        <td>{e.set}</td>
                                        <td>{e.iata}</td>
                                        <td>{e.aor}</td>
                                        <td>{e.aod}</td>
                                        
                                        <td>{e.aoa}</td>
                                        <td>{e.fpod}</td>
                                    </tr>
                                    : <></>
                            }
                            {
                                (!loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.RATE_SOURCES) && !isMobile) ?
                                    <ChargeTable charge={e.charges} />
                                    : <></>
                            }
                            {
                                (!loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.RATE_SOURCES) && !isMobile) ?
                                    <tr style={{ color: '#a30' }}>
                                        <td colSpan='6'>
                                            Sources :<br/>
                                            {
                                                Object.keys(e.sources).map(k => <p>{JSON.stringify(e.sources[k])}</p>)
                                            }
                                        </td>
                                    </tr>
                                    : <></>
                            }
                            {
                                (route.schedule) ?
                                    <tr style={{ color: '#a30' }}>
                                        <td colSpan='6'>
                                            {
                                                <AirPricingSchedule
                                                    skipvalidation={true} pricingRec={e} data={route.schedule} contract={e.dummyContract} subscript={subscript}
                                                    hideme={setcwfVisible} cwfVisible={cwfVisible} />
                                            }
                                        </td>
                                    </tr>
                                    : <></>
                            }
                            {
                                !(route.schedule) ?
                                    <tr style={{ color: '#a30' }}>
                                        <td colSpan='6'>
                                            <AirPricingSchedule pricingRec={e} contract={e.dummyContract} isDummy={true} subscript={subscript}
                                                hideme={setcwfVisible} cwfVisible={cwfVisible} />
                                        </td>
                                    </tr>
                                    : <></>
                            }
                        </>
                        })
                    }
                </tbody>
            </table>
        </>
    )
}